import { useMemo } from "react";
import { tryParseJson } from "@mssi/pssp-shared";

const useCachedObjectMemo = <T extends any>(value: T): T => {
  const stringValue = value === undefined ? undefined : JSON.stringify(value);
  return useMemo(() => (stringValue === undefined ? undefined : tryParseJson(stringValue)), [stringValue]) as T;
};

export default useCachedObjectMemo;
